module.exports = __webpack_public_path__ + "04fd1a4e1614f0810c8a548dc211aaee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/zaha.png
// module id = wAEA
// module chunks = 0